"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.throwErrorAsync = void 0;

var throwErrorAsync = function throwErrorAsync(error) {
  setTimeout(function () {
    throw error;
  }, 0);
};

exports.throwErrorAsync = throwErrorAsync;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/utils/ThrowError.js
// module id = 261
// module chunks = 209 210 211 212